<div class="mb-search-results-headline text-white h4"
     data-cy="mb-search-results-headline"
     [innerHTML]="searchResultsHeadline$ | async"
     *ngIf="(query$ | async) && !hasRedirectUrl && !isNonEmptySearch">
</div>
